@let selectedNavItem = this.basicLayoutHelperService.selectedNavItem();

@if (selectedNavItem) {
  <header
    pmResponsiveCardGrid
    #grid="responsiveCardGrid"
    class="flex justify-center"
    [ngClass]="isHomePage() ? 'px-12 py-3' : 'p-4'"
  >
    <div
      class="flex flex-row gap-2 justify-between w-full"
      [style.max-width]="isHomePage() ? grid.containerMaxWidth : null"
    >
      <div class="flex flex-col gap-1">
        <!-- text instead of back button -->
        @if (selectedNavItem.replaceNavigateBackText) {
          <p
            class="text-sm"
            [ngClass]="
              isHomePage()
                ? 'text-content-default font-normal'
                : 'text-content-body-text'
            "
          >
            {{ selectedNavItem.replaceNavigateBackText | translate }}
          </p>
        } @else {
          <pm-link
            text="BASIC_LAYOUT.BACK"
            (handleClick)="this.location.back()"
            size="large"
            [icon]="arrowLeftIcon"
          />
        }

        @let dynamicHeadline =
          selectedNavItem.dynamicHeadline
            ? selectedNavItem.dynamicHeadline()
            : null;
        @if (isHomePage()) {
          <pm-h2>
            {{
              dynamicHeadline
                ? (dynamicHeadline | translate)
                : (selectedNavItem.alternativeHeadlineTitle ??
                    selectedNavItem.title | translate)
            }}
          </pm-h2>
        } @else {
          @let headlineSuffix = selectedNavItem.headlineSuffixComponent;
          <div
            [ngClass]="headlineSuffix ? 'flex items-center gap-2' : 'contents'"
          >
            @if (selectedNavItem.headlineComponent && dynamicHeadline) {
              <ng-container
                *ngComponentOutlet="selectedNavItem.headlineComponent"
              />
            } @else {
              <pm-h1 [dataTestid]="this.headingTestId()">
                {{
                  dynamicHeadline
                    ? (dynamicHeadline | translate)
                    : (selectedNavItem.alternativeHeadlineTitle ??
                        selectedNavItem.title | translate)
                }}
              </pm-h1>
            }
            @if (headlineSuffix) {
              <ng-container *ngComponentOutlet="headlineSuffix" />
            }
          </div>
        }
      </div>
      <!-- dynamically add header component -->
      @let headerComponent = this.headerComponent();
      @if (headerComponent) {
        <div class="flex flex-col justify-center">
          <ng-container *ngComponentOutlet="headerComponent" />
        </div>
      }
    </div>
  </header>
}
